'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPotentialResponders = undefined;

var _reselect = require('reselect');

var _buildPotentialResponders = require('conversations-schema/operators/widget-data/buildPotentialResponders');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _getAgentRespondersList = require('./getAgentRespondersList');

var getPotentialResponders = exports.getPotentialResponders = (0, _reselect.createSelector)([_getWidgetData.getWidgetData, _getAgentRespondersList.getAgentRespondersList], _buildPotentialResponders.buildPotentialResponders);


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getPotentialResponders.js
// module id = 235
// module chunks = 2 3